import { render, staticRenderFns } from "./ExportCustomers.vue?vue&type=template&id=12bd15ae&scoped=true&"
import script from "./ExportCustomers.vue?vue&type=script&lang=js&"
export * from "./ExportCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ExportCustomers.vue?vue&type=style&index=0&id=12bd15ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd15ae",
  null
  
)

export default component.exports